import { translate } from "app/filters/i18nFilter";

import { StyledTopCompaniesAnimativeLoadingView, StyledTopCompaniesLoading } from "./styles";

const LOADING_TEXTS = Array.from(
    { length: 3 },
    (_, i) => translate(`si.top-companies.loading-state.text-${i + 1}`) + "...",
);

const TopCompaniesLoading = () => {
    return (
        <StyledTopCompaniesLoading
            justifyContent="center"
            alignItems="center"
            alignSelf="stretch"
        >
            <StyledTopCompaniesAnimativeLoadingView
                texts={LOADING_TEXTS}
                size="196px"
            />
        </StyledTopCompaniesLoading>
    );
};

export default TopCompaniesLoading;
